// extracted by mini-css-extract-plugin
export default {"appleLogin":"AppleLoginButton_appleLogin__dszxb"};